import styles from "./product-list-item-skeleton.module.css";
import Skeleton from "@/components/Skeleton/Skeleton";

export default function ProductListItemSkeleton() {
  return (
    <div className={styles.container}>
      <Skeleton type="image" />
      
      <div className={`${styles.listItemSkeletonGroup}`}>
        <Skeleton width={'100%'} />
        <Skeleton type="line-long" />
        <Skeleton type="paragraph" />
      </div>

      <Skeleton type="button" />
      <Skeleton type="button-small" />
    </div>
  );
};
